import { z } from "zod";

const BrowseModelsSchema = z.object({
  search: z.string(),
  page: z.number().min(1, { message: "Page is out of bounds" }),
  query: z.any().optional(),
  sort: z.array(z.object({ property: z.string(), asc: z.boolean() })).optional(),
});

export default BrowseModelsSchema;
